import type { AgencyProfile } from './agency-profile';
import type { AgentProfile } from './agent-profile';

export * from './address-details';
export * from './agency-profile';
export * from './agent-profile';
export * from './gallery-asset';
export * from './profile-page.types';
export * from './profile-theme.types';

export function isAgentProfile(propertyType: AgentProfile | AgencyProfile): propertyType is AgentProfile {
  // SAFETY(legacy): unreviewed, pre-dates this rule.
  return (propertyType as AgentProfile).isAgent !== undefined;
}
